import { agentV2SourceKey } from '@/agent-v2/references/agent-v2-source-key'
import { selectAgentV2ReferencesByCitationId } from '@/agent-v2/references/store/selectors'
import type { RootState } from '@/store/store'
import { useAppSelector } from '@/store/store-hooks'
import { selectDraftFootnoteNumberBySourceKey } from '../store/selectors'

/** The footnote number the draft gives a cited source, to show beside the source's title. Null when the draft gives it none. */
export function useDraftSourceFootnoteNumber(props: { conversationId: string | undefined; citationId: string | undefined }): number | null {
  const { conversationId, citationId } = props
  const reference = useAppSelector((state: RootState) =>
    citationId ? selectAgentV2ReferencesByCitationId(state, { conversationId: conversationId ?? '' })[citationId] : undefined
  )
  // Selected as the number itself, so a draft edit that leaves it unchanged re-renders nothing here.
  return useAppSelector((state: RootState) => (reference ? selectDraftFootnoteNumberBySourceKey(state)[agentV2SourceKey(reference)] : undefined) ?? null)
}
